module.exports = __webpack_public_path__ + "img/banner1.0bbe5fa8.png";